import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { adminHomePath, isUser } from '../support/accountFunction';

function UserRoute({ children }) {
  const { user, account, memberships, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-slate-200 border-t-forge-600" />
      </div>
    );
  }

  if (!isUser(user)) {
    return <Navigate to={adminHomePath()} replace />;
  }

  if (memberships.length > 1 && !account) {
    return <Navigate to="/select-account" replace />;
  }

  if (memberships.length === 0) {
    return <Navigate to="/select-account" replace />;
  }

  return children;
}

export default UserRoute;
